import script from "./ForgotPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=df797f82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df797f82"]])

export default __exports__